export default __webpack_public_path__ + "media/images/wing-93ed925e0b0d954531f8f9f96541096b.png";